
import Vue from "vue"
import ArticleItem from "../blog/articleItem.vue";
import SvgIcon from '@/components/svgIcon/index.vue'
import { faPlay } from "@fortawesome/free-solid-svg-icons";

export default Vue.extend({
	components: {
		ArticleItem,
		SvgIcon
	},
	props: ["content"],

	computed: {
		play: () => faPlay
	},
})
